import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from './axiosBaseQuery';

export const rtkQueryApi = createApi({
  reducerPath: 'api',
  baseQuery: axiosBaseQuery(),
  keepUnusedDataFor: 0,
  tagTypes: [
    'OdpAssessment',
    'HasCompletedOdpAssessment',
    'OnlineSpeakingMonitoring',
    'OsmMonitoring',
    'OdpMonitoring',
    'LifeSkillsMonitoring',
    'SpeakingMonitoring',
    'EorSpeakingMonitoring',
    'Training',
    'ExaminerStatus',
    'BulkImport',
    'Examiner',
    'ExaminerContactDetails',
    'OnlineMeetingProvider',
    'SpeakingCertification',
    'SpeakingCertificationList',
    'WritingCertification',
    'WritingCertificationList',
    'LifeSkillsCertification',
    'LifeSkillsCertificationList',
    'Disciplinary',
    'Communication',
    'Documents',
    'CentreAffiliation',
    'DistrictAffiliation',
    'Users',
  ],
  endpoints: () => ({}),
});
